export interface BorderMarketTime {
  isTimeDifference: boolean;
  aheadCustomer: boolean;
  timeDescription: string;
  newLoadingTime: string;
  longDesc: string;
}
